import { FC } from "react";

import { Grid } from "@mui/material";

type FormV2BuyerInformationSectionLayoutProps = {
  slots: {
    email: React.ReactNode;
    firstName: React.ReactNode;
    lastName: React.ReactNode;
    publicDonation?: React.ReactNode;
    address?: React.ReactNode;
    city?: React.ReactNode;
    postalCode?: React.ReactNode;
    country: React.ReactNode;
    region: React.ReactNode;
    organizationDonation?: React.ReactNode;
  };
};

export const FormV2BuyerInformationSectionLayout: FC<FormV2BuyerInformationSectionLayoutProps> = ({ slots }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        {slots.email}
      </Grid>
      <Grid item xs={12} sm={6}>
        {slots.firstName}
      </Grid>
      <Grid item xs={12} sm={6}>
        {slots.lastName}
      </Grid>
      {slots.publicDonation && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.publicDonation}
        </Grid>
      )}
      {slots.address && (
        <Grid item xs={12}>
          {slots.address}
        </Grid>
      )}
      {slots.city && (
        <Grid item xs={12} sm={6}>
          {slots.city}
        </Grid>
      )}
      {slots.postalCode && (
        <Grid item xs={12} sm={6}>
          {slots.postalCode}
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        {slots.country}
      </Grid>
      <Grid item xs={12} sm={6}>
        {slots.region}
      </Grid>
      {slots.organizationDonation && (
        <Grid item xs={12} sx={{ marginBlock: 1 }}>
          {slots.organizationDonation}
        </Grid>
      )}
    </Grid>
  );
};
